import { render, staticRenderFns } from "./nearby.vue?vue&type=template&id=252bd169&"
import script from "./nearby.vue?vue&type=script&lang=js&"
export * from "./nearby.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports